// Stand-in nicknames for the leaderboard in the iOS app. A nickname typed by
// another player is user-generated content, and App Review guideline 1.2
// demands report / block / filter tools for that; showing a word from our own
// list instead keeps the board alive without it. The player's own row keeps
// the name they typed. Web and Android show the real names.

// One word each, in the style players actually type (telemetry, 2026-11):
// short Latin handles, Russian first names and nicknames, a digit here and there.
export const PSEUDONYMS = [
  'Alexx', 'Dimon', 'Maks77', 'Tolik', 'Rustam', 'Kostya', 'Sanya', 'Vovan',
  'Lexa', 'Glebus', 'Timka', 'Marat', 'Ruslan', 'Ilyas', 'Tyoma', 'Gosha',
  'nomad', 'dusty', 'kraken', 'vortex', 'Zed', 'Rex', 'pixel', 'raider',
  'bandit', 'sultan', 'camel', 'dervish', 'ataman', 'Khan', 'rogue', 'ghost',
  'Neo', 'Tank', 'wolf', 'fox', 'bobr', 'kotik', 'pelmen', 'kefir',
  'Kuzya', 'Babai', 'Sonya', 'Mira', 'Zlata', 'Yana', 'kir2', 'NB7',
  'Саня', 'Лёха', 'Димон', 'Тоха', 'Серый', 'Макс', 'Гена', 'Борян',
  'Кирюха', 'Стас', 'Витёк', 'Жека', 'Миха', 'Толян', 'Юрец', 'Ильдар',
  'Тимур', 'Арсен', 'Гоша', 'Колян', 'Валера', 'Лена', 'Катя', 'Даша',
  'кочевник', 'бархан', 'суслик', 'верблюд', 'тушкан', 'шакал', 'варан', 'сайгак',
];

// True inside the iOS wrapper: GameView serves the game on corovans://app/.
export function isIosApp() {
  return typeof location !== 'undefined' && location.protocol === 'corovans:';
}

function hashName(name) {
  let h = 2166136261;
  for (const ch of name) h = Math.imul(h ^ ch.codePointAt(0), 16777619);
  return h >>> 0;
}

// Same entries with every other player's name swapped for a pseudonym. The
// word depends only on the real name, so a player keeps theirs between
// fetches; two rows never share one. Nameless rows ('???') are left as is.
export function pseudonymiseLeaderboard(entries, ownName) {
  const own = (ownName || '').trim().toLowerCase();
  const used = new Set();
  return entries.map((e) => {
    const name = (e.name || '').trim();
    if (!name || name === '???' || name.toLowerCase() === own) return e;
    let i = hashName(name.toLowerCase()) % PSEUDONYMS.length;
    while (used.has(i) && used.size < PSEUDONYMS.length) i = (i + 1) % PSEUDONYMS.length;
    used.add(i);
    return { ...e, name: PSEUDONYMS[i] };
  });
}
